// Dependencias generales
import React from "react";
import { useEffect } from 'react';


// Función del router
const InstalersList = (params) => {    

    useEffect(() => {                 
      console.log("Componente del listado de instaladores cargado correctamente.")

    }, [params]);

    if(params.objListadoInstaladores.length > 0){
      const listInstallers = params.objListadoInstaladores.map((installer,index) =>

        <React.Fragment key={installer.phoneNumber.replaceAll(" ","")+"-"+index}>
        
          <li id={installer.phoneNumber.replaceAll(" ","")+"-"+index} className="" > 
            <div className="selector front gap-02">
              <div className="horizontal gap-04 start">
                <div className="vertical gap-04 fill">                    
                  <div className="vertical fill gap-01">
                    <span className="headline-03">{installer.name}</span>   
                    <div className="horizontal gap-02" >
                      <span id="rankingInstalador1" className="rating horizontal gap-02 material-icon" style = {{"--rating": installer.rating}}>star star star star star</span> 
                      ( {installer.votes} Reseñas )                                          
                    </div>                 
                  </div>
                </div>
                <a href={"tel://"+installer.phoneNumber.replaceAll(" ","")} className="button rounded"><span className="material-icon">call</span></a>
              </div>
              <span className="size-m">{installer.address}</span>
              <div className="horizontal gap-02" >
                <span className="size-m">{installer.phoneNumber}</span> 
                |
                {installer.openingStatus === "True" ?
                  <span className="size-m horizontal gap-01 store-open">Abierto</span>
                  :
                  [installer.openingStatus === "False"?
                    <span className="size-m horizontal gap-01 store-closed">Cerrado</span>
                    :
                    <span className="size-m horizontal gap-01">No disponible</span>
                  ]                    
                }                                    
              </div>
            </div>
            
          </li>

        </React.Fragment>
      );    

      return (
        <>        
        {listInstallers}          
        </>
      )
    }
    else{      
      return (
        <p>No hay instaladores disponibles.</p>
      );
    }
}

export default InstalersList